import { render, staticRenderFns } from "./animat-upload.vue?vue&type=template&id=598495b2&scoped=true&"
import script from "./animat-upload.vue?vue&type=script&lang=js&"
export * from "./animat-upload.vue?vue&type=script&lang=js&"
import style0 from "./animat-upload.vue?vue&type=style&index=0&id=598495b2&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598495b2",
  null
  
)

export default component.exports